<template>
	<div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Detail Paket</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Detail Paket</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
                
				<div class="custom-container">

					<div class="row">
						
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
							<Sidebar />
						</div>
						<!-- / Profile Sidebar -->
						
						<div class="col-md-7 col-lg-8 col-xl-9">

                            <!-- Librarian Widget -->
                            <div class="card">
                                <div class="card-body">
                                    <div class="sender-widget">
                                        <div class="doc-info-left">
                                            <div class="sender-img">
                                                <img v-bind:src="paket.url_gambar" class="img-fluid" alt="User Image">
                                            </div>
                                            <div class="doc-info-cont">
                                                <h4 class="doc-name">{{paket.nama_paket}}</h4>
                                                <p class="doc-department">
                                                    <!-- <img v-bind:src="paket.url_gambar" class="img-fluid" alt="Speciality"> -->
                                                    {{paket.nama_tipe}}</p>
                                                <div class="rating">
                                                    <i class="fas fa-star filled"></i>
                                                    <i class="fas fa-star filled"></i>
                                                    <i class="fas fa-star filled"></i>
                                                    <i class="fas fa-star filled"></i>
                                                    <i class="fas fa-star"></i>
                                                    <!-- <span class="d-inline-block average-rating">(35)</span> -->
                                                </div>
                                                <div class="shop-details">
                                                    <p class="doc-location"><i class="fas fa-map-marker-alt"></i> Online </p>
                                                </div>
                                                <div class="shop-services" v-if="paket.fg_slot == '2'">
                                                    <span>Tersedia {{paket.slot}} Slot</span>
                                                    <!-- <span>Diversity & Inclusion</span>
                                                    <span>Campus Activities</span>
                                                    <span>Student Support</span> -->
                                                </div>
                                            </div>
                                        </div>
                                        <div class="doc-info-right">
                                            <div class="clini-infos">
                                                <!-- <ul>
                                                    <li><i class="far fa-thumbs-up"></i> 99%</li>
                                                    <li><i class="fab fa-whatsapp"></i> 0812-3456-789</li>
                                                    <li><i class="fas fa-clock"></i> 200+ Session </li>
                                                </ul> -->
                                            </div>
                                            <div class="sender-action">
                                                <button class="btn btn-block btn-outline-primary active" @click.prevent="getCheckout(paket)"  v-if="paket.isalreadybeli != '1' && paket.isalreadybeli != '2'">
                                                    Beli Paket
                                                </button>
                                                <button class="btn btn-primary" style="width:100%" @click.prevent="lihatInvoice(paket)" v-if="paket.isalreadybeli == '2'">
                                                    Lihat Invoice
                                                </button>
                                                <button class="btn btn-primary" style="width:100%" @click.prevent="mulaiBelajar(paket)" v-if="paket.isalreadybeli == '1'">
                                                    Ayo Mulai Belajar
                                                </button>
                                                <!-- <a href="javascript:void(0)" class="btn btn-white fav-btn">
                                                    <i class="far fa-bookmark"></i>
                                                </a>
                                                <router-link to="/instructor/chat" class="btn btn-white msg-btn">
                                                    <i class="far fa-comment-alt"></i>
                                                </router-link>
                                                <a href="javascript:void(0)" class="btn btn-white call-btn" data-toggle="modal" data-target="#voice_call">
                                                    <i class="fas fa-phone"></i>
                                                </a>
                                                <a href="javascript:void(0)" class="btn btn-white call-btn" data-toggle="modal" data-target="#video_call">
                                                    <i class="fas fa-video"></i>
                                                </a> -->
                                            </div> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- /Librarian Widget -->
                            
                            <!-- Librarian Details Tab -->
                            <div class="card">
                                <div class="card-body pt-0">
                                
                                    <!-- Tab Menu -->
                                    <nav class="user-tabs mb-4">
                                        <ul class="nav nav-tabs nav-tabs-bottom nav-justified">
                                            <li class="nav-item">
                                                <a class="nav-link active" href="#doc_overview" data-toggle="tab">Overview</a>
                                            </li> 
                                            <li class="nav-item">
                                                <a class="nav-link" href="#doc_reviews" data-toggle="tab">Materi dan Latihan</a>
                                            </li>
                                            <li class="nav-item" v-if="paket.tipe_paket=='2'">
                                                <a class="nav-link" href="#doc_business_hours" data-toggle="tab">Jadwal Bimbel</a>
                                            </li>
                                        </ul>
                                    </nav>
                                    <!-- /Tab Menu -->
                                    
                                    <!-- Tab Content -->
                                    <div class="tab-content pt-0">
                                    
                                        <!-- Overview Content -->
                                        <div role="tabpanel" id="doc_overview" class="tab-pane fade show active">
                                            <div class="row">
                                                <div class="col-md-12 col-lg-9">
                                                
                                                    <!-- About Details -->
                                                    <div class="widget about-widget">
                                                        <h4 class="widget-title">Informasi</h4>
                                                        <p class="widget-p">{{paket.deskripsi}}</p>
                                                    </div>
                                                    <!-- /About Details -->
                                                
                                                </div>
                                                <div class="col-md-12 col-lg-3">
                                                
                                                    <!-- About Details -->
                                                    <div class="widget about-widget">
                                                        <h4 class="widget-title">Benefit</h4>
                                                        <div class="comment-body">
                                                            <p class="recommended" v-for="(ref) in paket.list_benefit" :key="ref">
                                                                <!-- <i class="far fa-check-circle"></i>  -->
                                                                <img class="avatar rounded-circle" alt="User Image" src="https://img.icons8.com/external-febrian-hidayat-gradient-febrian-hidayat/64/000000/external-check-ui-essential-febrian-hidayat-gradient-febrian-hidayat.png" style="margin-right: 16px;">
                                                                
                                                                {{ref.nama_benefit}}
                                                            </p>    
                                                            <!-- <p class="recommended"><i class="far fa-check-circle"></i> I recommend the sender</p>    
                                                            <p class="recommended"><i class="far fa-check-circle"></i> I recommend the sender</p>    
                                                            <p class="recommended"><i class="far fa-check-circle"></i> I recommend the sender</p>     -->
                                                        </div>
                                                    </div>
                                                    <!-- /About Details -->
                                                
                                                </div>
                                            </div>
                                        </div>
                                        <!-- /Overview Content -->
                                        
                                        <!-- Reviews Content -->
                                        <div role="tabpanel" id="doc_reviews" class="tab-pane fade">
                                            <div class="row">
                                                <div class="col-md-7">
                                                    <section class="comp-section">
                                                        <div class="comp-header">
                                                            <h3 class="comp-title">Daftar Materi</h3>
                                                            <div class="line"></div>
                                                        </div>
                                                        <div class="card">
                                                            <div class="card-body">
                                                                
                                                                <!-- Review Listing -->
                                                                <div class="widget review-listing">
                                                                    <ul class="comments-list">
                                                                        <li v-for="(ref, index) in paket.list_materi" :key="ref">
                                                                            <div class="comment">
                                                                                <img class="avatar avatar-sm rounded-circle" alt="User Image"  v-bind:src="((index+1>=22)?'https://img.icons8.com/color/48/undefined/':'https://img.icons8.com/plasticine/100/000000/')+(index+1)+((index+1>9)?'':'-circle')+'.png'">
                                                                                <div class="comment-body">
                                                                                    <div class="meta-data">
                                                                                        <span class="comment-author">{{ref.nama_materi}}</span>
                                                                                        <span class="comment-date">{{ref.nama_tingkatan}}</span>
                                                                                        <!-- <div class="review-count rating">
                                                                                            <i class="fas fa-star filled"></i>
                                                                                            <i class="fas fa-star filled"></i>
                                                                                            <i class="fas fa-star filled"></i>
                                                                                            <i class="fas fa-star filled"></i>
                                                                                            <i class="fas fa-star"></i>
                                                                                        </div> -->
                                                                                    </div>
                                                                                    <!-- <p class="recommended"><i class="far fa-thumbs-up"></i> I recommend the sender</p>
                                                                                    <p class="comment-content">
                                                                                        Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                                                                                        sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                                                                                        Ut enim ad minim veniam, quis nostrud exercitation.
                                                                                        Curabitur non nulla sit amet nisl tempus
                                                                                    </p> -->
                                                                                    
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                        
                                                                    
                                                                        
                                                                    </ul>
                                                                    
                                                            
                                                                    
                                                                </div>
                                                                <!-- /Review Listing -->
                                                            </div>
                                                        </div>
                                                    </section>
                                                </div>
                                                <div class="col-md-5">
                                                    <section class="comp-section">
                                                        <div class="comp-header">
                                                            <h3 class="comp-title">Latihan Soal</h3>
                                                            <div class="line"></div>
                                                        </div>
                                                        <div class="card">
                                                            <div class="card-body">
                                                                
                                                                <!-- Review Listing -->
                                                                <div class="widget review-listing">
                                                                    <ul class="comments-list">
                                                                        <li v-for="(ref, index) in paket.list_tryout" :key="ref">
                                                                            <div class="comment">
                                                                                <img class="avatar avatar-sm rounded-circle" alt="User Image"  v-bind:src="((index+1>=22)?'https://img.icons8.com/color/48/undefined/':'https://img.icons8.com/plasticine/100/000000/')+(index+1)+((index+1>9)?'':'-circle')+'.png'">
                                                                                <div class="comment-body">
                                                                                    <div class="meta-data">
                                                                                        <span class="comment-author">{{ref.nama_to}}</span>
                                                                                        <!-- <span class="comment-date">{{ref.nama_tingkatan}}</span> -->
                                                                                        <!-- <div class="review-count rating">
                                                                                            <i class="fas fa-star filled"></i>
                                                                                            <i class="fas fa-star filled"></i>
                                                                                            <i class="fas fa-star filled"></i>
                                                                                            <i class="fas fa-star filled"></i>
                                                                                            <i class="fas fa-star"></i>
                                                                                        </div> -->
                                                                                    </div>
                                                                                    <!-- <p class="recommended"><i class="far fa-thumbs-up"></i> I recommend the sender</p>
                                                                                    <p class="comment-content">
                                                                                        Lorem ipsum dolor sit amet, consectetur adipisicing elit,
                                                                                        sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                                                                                        Ut enim ad minim veniam, quis nostrud exercitation.
                                                                                        Curabitur non nulla sit amet nisl tempus
                                                                                    </p> -->
                                                                                    
                                                                                </div>
                                                                            </div>
                                                                        </li>
                                                                        
                                                                    
                                                                        
                                                                    </ul>
                                                                    
                                                            
                                                                    
                                                                </div>
                                                                <!-- /Review Listing -->
                                                            </div>
                                                        </div>
                                                    </section>
                                                </div>
                                            </div>
                                        
                                        </div>
                                        <!-- /Reviews Content -->
                                        
                                        <!-- Business Hours Content -->
                                        <div role="tabpanel" id="doc_business_hours" class="tab-pane fade">
                                            <div class="row">

                                                
                                                    <div class="col-md-6"  v-for="(ref, index) in paket.list_jadwal" :key="ref">
                                                        <!-- {{randomLabel(index)}} -->
                                                        <div class="kt-widget2  box-shadow" >
                                                            <div class="kt-widget2__item " :class="['kt-widget2__item--'+labelBox[(index%4)+1]]" >
                                                                <div class="kt-widget2__info">
                                                                    <div class="kt-widget2__checkbox">
                                                                    </div>
                                                                    <div class="kt-widget2__title">
                                                                        {{ref.judul_pertemuan}}
                                                                    </div>
                                                                    <!-- <a href="#" class="kt-widget2__username">
                                                                        by {{ref.nama_coach}}
                                                                    </a> -->
                                                                    <div class="kt-widget2__username">
                                                                        <span class=" text-info">{{ref.jadwal_pertemuan}}</span>
                                                                    </div>
                                                                </div>
                                                                
                                                            </div>
                                                        </div>
                                                    </div>

                                                <!-- <div class="col-md-6 offset-md-3">
                                                
                                                    <div class="widget business-widget">
                                                        <div class="widget-content">
                                                            <div class="listing-hours">
                                                                <div class="listing-day" v-for="(ref) in paket.list_jadwal" :key="ref">
                                                                    <div class="day">{{ref.judul_pertemuan}}</div>
                                                                    <div class="time-items">
                                                                        <span class="time">{{ref.jadwal_pertemuan}}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> -->
                                            </div>
                                        </div>
                                        <!-- /Business Hours Content -->
                                        
                                    </div>
                                </div>
                            </div>
                            <!-- /Librarian Details Tab -->

						</div>
                    </div>

				</div>

			</div>		
			<!-- /Page Content -->
   
			<!-- Footer -->
                <layout-footer />
			<!-- /Footer -->
		</div>
		
	</div>
		<!-- /Main Wrapper -->
</template>


<script>
// import instructors from '../../../assets/json/instructorslist'
// const images = require.context('@/assets/img/clients', false, /\.png$|\.jpg$/)
// import schoolvisits from '../../../assets/json/instructor/dashboard/schoolvisits'
// import coursetakenrecords from '../../../assets/json/instructor/dashboard/coursetakenrecords'
// import billing from '../../../assets/json/instructor/dashboard/billing'

import Sidebar from '../../Sidebar'
import axios from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery'

export default {
    components: {
        Sidebar
    },
	name: 'paket-belajar',
    // vuetify: new Vuetify(),
    data() {
        return {
            lstpaket: [],
            paket:{
                id_paket: '',
                nama_paket: '',
                tipe_paket: '',
                harga_awal: '',
                diskon: '',
				harga_aktif: '',
                masa_berlaku: '',
				jml_to: '',
                diskon_referral: '',
                komisi_referral: '',
                url_gambar: '',
                fg_publish: '',
                fg_pendaftaran: '',
                fg_favorit: '',
                url_telegram: '',
                slot: '',
                isalreadybeli: '',
                id_sales:''
            },
            lsttipe: [
                {id: '1', text: 'MANDIRI'},
                {id: '2', text: 'BIMBEL'}
            ],
            lststspublish: [
                {id: '1', text: 'DRAFT'},
                {id: '2', text: 'PUBLISH'}
            ],
            lststspendaftaran: [
                {id: '1', text: 'DITUTUP'},
                {id: '2', text: 'DIBUKA'}
            ],
            lststsfav: [
                {id: '1', text: 'TIDAK'},
                {id: '2', text: 'YA'}
            ],
			lstbenefit: [],
			lstjadwal: [],
			lsttryout: [],
			paketlsttryout: [],
			lstmateri: [],
			paketlstmateri: [],
            
            labelBox: [
                "brand", "warning","danger","success","primary"
            ],
            //     {id_paket_benefit: '1', nama_benefit: 'Benefit 1'},
			// ]
            // lstmateri: [],
            // materi:{
            //     id_materi: '',
            //     id_tingkatan: '',
            //     nama_materi: '',
            // },
            // lstsubmateri: [],
            // submateri: {
            //     id_sub_materi: '',
            //     id_materi: '',
            //     nama_sub_materi: '',
            // },
        }
    },
    created: function () {
        this.getPaket();

    },  

    methods: {
        
        
        getCheckout: function (ref) {
            localStorage.setItem("idPaket", ref.id_paket);  //idPaket: ref.id_paket,  
            this.$router.push({name:'siswa-paket-belajar-summmarycheckout'});//, params: {id: ref.id_paket}}); 
            
        },
         
        mulaiBelajar: function (ref) {
            localStorage.setItem("idPaket", ref.id_paket);  //idPaket: ref.id_paket,  
            this.$router.push({name:'siswa-paket-saya-detail'});         
        },
	
        lihatInvoice: function (ref) {
            localStorage.setItem("idPaket",  ref.id_sales); 
			if(parseInt(ref.harga_aktif) >0){
                // localStorage.setItem("idPaket", ref.id_paket);  //idPaket: ref.id_paket,  
                this.$router.push({name:'siswa-paket-belajar-invoice'}); //, params: {id: ref.id_paket}}    
            } else {
				this.$router.push({name:'siswa-paket-belajar-invoice-gratis'});//
            }     
        },

        getPaket: function () {
            axios.get('api/paketbelajar/'+localStorage.getItem('idUser')+'/'+localStorage.getItem("idPaket"))//this.$route.params.id)
                .then(res => {
                    // console.log(res.data);
                    this.paket = res.data.data;
                    // this.initDt("tblLatihan");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

    }
}
</script>


// WEBPACK FOOTER //
// src/components/Siswa/PaketBelajar/Detail/index.vue